import { Icon, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { thumbnailSize } from 'components/item-thumbnail-with-badge/styled';
import Picture from 'components/picture';
import SelectionsList from 'components/product/selections-list';
import { LogUserErrorSeverity, useGetAndLogUserErrorMessage } from 'hooks/log-user-error-message';
import { CartEntryType } from 'utils/cart';

import { ItemSelection, MappedCartEntry } from '../types';

import {
  DetailsContainer,
  InfoText,
  ItemContainer,
  ItemInfoContainer,
  ItemName,
  PictureContainer,
} from './styled';

const ItemOptionModifier = ({ itemSelection }: { itemSelection: ItemSelection[] }) => {
  const totalItems = itemSelection.length;
  const itemsString = itemSelection.map(selection => selection.element).join(', ');

  return totalItems > 2 ? (
    <Text fontSize="xs">{itemsString}</Text>
  ) : (
    <>
      {itemSelection.map(selection => (
        <ItemName isAvailable key={selection.id}>
          {selection.element}
        </ItemName>
      ))}
    </>
  );
};

export const MenuReorderItemsListItem = ({ item }: { item: MappedCartEntry }) => {
  const { formatMessage } = useIntl();
  const isAvailable = item.isAvailable;

  const itemOptionModifiers = item.itemSelections?.filter(
    modifier => modifier.type === CartEntryType.itemOptionModifier
  );

  const restModifiers = item.itemSelections?.filter(
    modifier => modifier.type !== CartEntryType.itemOptionModifier
  );

  const getItemCurrentlyNotAvailableMessage = useGetAndLogUserErrorMessage({
    message: formatMessage({ id: 'itemCurrentlyNotAvailable' }),
    severity: LogUserErrorSeverity.Informational,
    context: { moreInfo: 'is-reorder-card' },
  });

  return (
    <ItemContainer>
      {item?.image && (
        <PictureContainer>
          <Picture {...thumbnailSize} alt={item?.name || ''} image={item.image} />
        </PictureContainer>
      )}
      <DetailsContainer>
        <ItemName isAvailable={isAvailable}>{item?.name}</ItemName>
        {isAvailable ? (
          <>
            {itemOptionModifiers && <ItemOptionModifier itemSelection={itemOptionModifiers} />}
            <SelectionsList selections={restModifiers} id={item._id} expandable />
          </>
        ) : (
          <ItemInfoContainer>
            <Icon variant="infoFill" />
            <InfoText>
              {getItemCurrentlyNotAvailableMessage({
                name: item.name,
                vendorConfigs: item.vendorConfigs,
              })}
            </InfoText>
          </ItemInfoContainer>
        )}
      </DetailsContainer>
    </ItemContainer>
  );
};
